interface ILocalDeTrabalho {
  nome: string
}

interface IEmpregador {
  nome: string
  numeroIdentificador: string
  numeroIdentificadorTipo: string
}

interface IEmpregado {
  pin: string
  nome: string
  cpf: string
  atingiuLimiteDeBiometrias: boolean
  empregador: IEmpregador
  localDeTrabalho: ILocalDeTrabalho
}

export interface IBiometriaState {
  empregado: IEmpregado | null
}

interface IEmpregadoAPI {
  pin: string
  nome: string
  cpf: string
  limite_de_biometrias_atingido: boolean
  empregador: {
    nome: string
    numero_identificador: string
    numero_identificador_tipo: string
  }
  local_de_trabalho: {
    nome: string
  }
}

const defaultState = (): IBiometriaState => ({
  empregado: null,
})

const getters = {
  dadosEmpregado: (state: IBiometriaState): IEmpregado | null => state.empregado,
  possuiDadosEmpregado: (state: IBiometriaState): boolean => state.empregado !== null,
}

const mutations = {
  definirEmpregado(state: IBiometriaState, empregado: IEmpregadoAPI): void {
    state.empregado = {
      pin: empregado.pin,
      nome: empregado.nome,
      cpf: empregado.cpf,
      atingiuLimiteDeBiometrias: empregado.limite_de_biometrias_atingido,
      empregador: {
        nome: empregado.empregador.nome,
        numeroIdentificador: empregado.empregador.numero_identificador,
        numeroIdentificadorTipo: empregado.empregador.numero_identificador_tipo,
      },
      localDeTrabalho: {
        nome: empregado.local_de_trabalho.nome,
      },
    }
  },

  limpar(state: IBiometriaState): void {
    Object.assign(state, defaultState())
  },
}

const actions = {}

export default {
  namespaced: true,
  state: defaultState(),
  getters,
  mutations,
  actions,
}
